import { render, staticRenderFns } from "./UserInputValue.vue?vue&type=template&id=505edc2a&scoped=true&"
import script from "./UserInputValue.vue?vue&type=script&lang=js&"
export * from "./UserInputValue.vue?vue&type=script&lang=js&"
import style0 from "./UserInputValue.vue?vue&type=style&index=0&id=505edc2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505edc2a",
  null
  
)

export default component.exports